export default __webpack_public_path__ + "static/media/ravi.9a9eef01.png";